import SquareShapeComponent from "./square-shape-component";
import SquareShapeConfig from "./square-shape-config";
import SquareShapeAdvancedConfig from "./square-shape-advanced-config";

export default {
  SquareShapeComponent,
  SquareShapeConfig,
  SquareShapeAdvancedConfig
};
